import { defineComponent as I, computed as r, createElementBlock as y, openBlock as a, normalizeClass as i, createVNode as m, createBlock as n, createCommentVNode as c, unref as o, withCtx as d, resolveDynamicComponent as g } from "vue";
import { RevButtonBase as C } from "@ds/components/ButtonBase";
import { RevButtonIcon as p } from "@ds/components/ButtonIcon";
import { RevIllustration as D } from "@ds/components/Illustration";
import A from "../../../icons/generated/IconCross.vue2.js";
import L from "../../../icons/generated/IconDownload.vue2.js";
import { tw as s } from "../../../utils/tailwind.js";
import { isImage as b, isArchive as _, isTextDocument as $, isSpreadsheet as N, isPresentation as P } from "../Document.helpers.js";
import R from "../assets/IconArchive.vue.js";
import T from "../assets/IconDoc.vue.js";
import j from "../assets/IconImage.vue.js";
import S from "../assets/IconPDF.vue.js";
import V from "../assets/IconPresentation.vue.js";
import z from "../assets/IconSpreadsheet.vue.js";
import E from "./DocumentLabelWrapper.vue2.js";
import F from "./DocumentName.vue2.js";
const ae = /* @__PURE__ */ I({
  name: "DocumentDefault",
  __name: "DocumentDefault",
  props: {
    name: {},
    url: {},
    deletable: { type: Boolean },
    thumbnail: { type: Boolean },
    downloadButtonAriaLabel: {},
    deleteButtonAriaLabel: {}
  },
  emits: ["delete"],
  setup(h, { emit: k }) {
    const l = h, v = k, w = r(() => {
      const e = [
        { check: b, icon: j },
        { check: _, icon: R },
        { check: $, icon: T },
        { check: N, icon: z },
        { check: P, icon: V }
      ];
      for (const t of e)
        if (t.check(l.name)) return t.icon;
      return S;
    }), u = r(
      () => l.url && l.thumbnail && b(l.name)
    ), B = r(() => [
      s`border-static-default-mid group relative w-full border`,
      u.value && s`flex-col`
    ]), f = s`absolute bottom-12 right-12`;
    return (e, t) => (a(), y("article", {
      class: i(B.value)
    }, [
      m(o(C), {
        class: "focus-visible-outline-default-hi block max-w-full rounded-[5px]",
        target: "_blank",
        to: e.url
      }, {
        default: d(() => [
          u.value ? (a(), n(o(D), {
            key: 0,
            alt: "",
            height: 140,
            "image-class-names": "rounded-t-sm h-[8.75rem] w-full object-cover object-center",
            src: e.url,
            title: e.name,
            width: 448
          }, null, 8, ["src", "title"])) : c("", !0),
          m(E, { class: "w-full max-w-full overflow-hidden py-20 pr-48" }, {
            default: d(() => [
              (a(), n(g(w.value), {
                class: "shrink-0",
                height: "20",
                width: "20"
              })),
              m(F, { name: e.name }, null, 8, ["name"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"]),
      e.url && !e.deletable ? (a(), n(o(p), {
        key: 0,
        "aria-label": e.downloadButtonAriaLabel,
        class: i(f),
        download: e.name,
        icon: o(L),
        target: "_blank",
        to: e.url,
        variant: "secondary"
      }, null, 8, ["aria-label", "download", "icon", "to"])) : c("", !0),
      e.deletable ? (a(), n(o(p), {
        key: 1,
        "aria-label": e.deleteButtonAriaLabel,
        class: i(f),
        icon: o(A),
        variant: "secondary",
        onClick: t[0] || (t[0] = (q) => v("delete"))
      }, null, 8, ["aria-label", "icon"])) : c("", !0)
    ], 2));
  }
});
export {
  ae as default
};
